angular.module('aprima-provider-api')
    .factory('VersionService', ['VersionServiceTs', function (VersionServiceTs) {
        'use strict';

        function checkVersions(userLoginInfo) {
            return VersionServiceTs.ensureVersions(userLoginInfo).then(function() {
                return VersionServiceTs.checkVersions(userLoginInfo.SupportedApiVersions, userLoginInfo.MinClientVersion);
            });
        }

        return {
            checkVersions: checkVersions,
        };
    }]);
